<template lang="pug">
    Col(span="11")
        //- pre {{item}}
        Card(:bordered="false" style="min-height: 550px;max-height:800px;" dis-hover)
            pre(slot="title") {{item.canEdit?$t("groupPattern.customize"): $t("groupPattern.default")}}
            div(slot="extra")
                Button(v-if="item.canEdit" @click="editItem" icon="md-settings")
                Button(@click="updateItem(item.value)" :disabled="item.value == currentuse") {{item.value == currentuse ? $t("groupPattern.applied"): $t("groupPattern.apply")}}
            div
                Layout(style="min-width: 30vw; max-height: 60vh")
                    Content(:style="item.contentStyle")
                        Card.loginCard(dis-hover)
                            img(src="../../../static/customizeTemplate/no-image.png" v-real-img="item.logoUrl" style="max-height: 100px;max-width: 360px")
                            Divider
                            p.login-description {{ item.loginDescription }}
                            Form
                                FormItem
                                    div(class="ivu-input" placeholder="Username" suffix="md-person" :style="item.layout.ivuInput")
                                FormItem
                                    div(class="ivu-input" type="password" password placeholder="Password" :style="item.layout.ivuInput")
                                FormItem
                                    div(class="ivu-input" placeholder="Token" suffix="md-key" :style="item.layout.ivuInput")
                                FormItem
                                    Button(:style="item.layout.loginBtn") Login
            Modal(v-model="isEditing" title="Edit Customize Login Page" width="1200")
                Row(style="display:flex;flex-direction:row;justify-content: space-evenly;align-items:center")
                    Col(span="12")
                        Layout(style="height: 50vh")
                            Content(:style="sketchContent")
                                Card.loginCard(dis-hover)
                                    img(src="../../../static/customizeTemplate/no-image.png" v-real-img="previewLoginLogoImg" v-if="!isCleared&&previewLoginLogoImg!== ''" style="max-height: 100px")
                                    div(style="border: 1px dashed black;width:150px" v-else)
                                        p {{$t("groupPattern.loginPageObject.logo")}}
                                    Divider
                                    p.login-description(v-if="showDescriptionPreview") {{editItemData.loginDescription}}
                                    div(style="border: 1px dashed black;width:150px; margin-bottom: 10px" v-else)
                                        p {{$t("groupPattern.loginPageObject.description")}}

                                    div(style="border: 1px dashed black;width:150px;margin-bottom: 10px" v-if="!showInputPreview")
                                        pre {{$t("groupPattern.loginPageObject.inputStyle")}}
                                    Form(v-else)
                                        FormItem
                                            div(class="ivu-input" placeholder="Username" suffix="md-person" :style="`{${editItemData.layout.ivuInput}}`")
                                    div(style="border: 1px dashed black;width:150px" v-if="!showBtnPreview")
                                        pre {{$t("groupPattern.loginPageObject.btnStyle")}}
                                    Form(v-else)
                                        FormItem
                                            Button(:style="`{${editItemData.layout.loginBtn}}`") Login
                    Col(span="9")
                        .flexRow(v-for="uploadItem in uploadImageItems" :key="uploadItem.name" style="justify-content: space-between")
                            pre {{uploadItem.name}}
                            div(style="display: flex; flex-direction: row")
                                Upload(ref="uploads" name="uploads"
                                        :format="uploadItem.handleUpload.format"
                                        :show-upload-list="false"
                                        :action="`/api/uploads/${uploadItem.uploadEndPoint}?groupName=${groupName}`"
                                        v-bind:with-credentials="true"
                                        :on-format-error="handleFormatError"
                                        :on-success="uploadSuccess"
                                        :before-upload="(...args) => { handleBeforeUpload(uploadItem, ...args); }"
                                        )
                                    Button(
                                        :disabled="disabled"
                                        icon="ios-cloud-upload-outline"
                                        style="width: 100%;") {{uploadItem.handleUpload.format | arrayToString}}
                                    br
                            div(style="display: flex; flex-direction: row")
                                Button(@click="clearImage(uploadItem)" icon="md-trash")
                                Button(@click="applyDefaultImg(uploadItem)") {{$t("groupPattern.applyDefault")}}


                        .flexRow(style="margin-bottom: 10px")
                            pre {{$t("groupPattern.loginPageObject.description")}}
                            Input(v-model="editItemData.loginDescription" @input="showDescriptionPreview = true;config.logindescription = editItemData.loginDescription;descriptionHasChanged = true")
                            Button(@click="applyDefaultDescription") {{$t("groupPattern.applyDefault")}}
                        div(style="border: 1px solid #dee0e3;padding: 0 10px")
                            .flexRow
                                pre {{$t("groupPattern.loginPageObject.style")}}
                                Button(@click="applyDefaultLayout") {{$t("groupPattern.applyDefault")}}
                            div
                                pre {{$t("groupPattern.loginPageObject.inputStyle")}}
                                prism-editor.codeEditor(:highlight="highlighter" v-model="editItemData.layout.ivuInput" @input="showInputPreview = true;config.layout = 1;$emit('input', config);layoutHasChanged = true")
                                pre {{$t("groupPattern.loginPageObject.btnStyle")}}
                                prism-editor.codeEditor(:highlight="highlighter" v-model="editItemData.layout.loginBtn" @input="showBtnPreview = true;config.layout = 1;$emit('input', config);layoutHasChanged = true")
                div(slot="footer")
                    Button(size="large" long type="primary" @click="updateEditItemData") {{$t("groupPattern.updateText")}}



</template>
<script>
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-css";
import "prismjs/themes/prism-tomorrow.css";

import {
    updateGroupPattern,
    getGroupPrefs,
    getGroupLoginPageLayout,
    updateCustomizeLoginPageLayout,
    updateGroupInfo,
    clearGroupImage,
} from "@/api/group";

export default {
    props: ["groupName", "disabled", "item", "currentuse", "isCleared"],
    components: { PrismEditor },
    data() {
        return {
            layoutHasChanged: false,
            descriptionHasChanged: false,
            defaultImgMap: {},
            defaultLayout: {},
            defaultDescription: "",
            editItemData: {
                name: "customize",
                canEdit: true,
                loginDescription: "",
                layout: { ivuInput: "", loginBtn: "" },
                logoUrl: "",
            },
            isEditing: false,
            previewBackgroundImg: "",
            previewLoginLogoImg: "",
            showDescriptionPreview: false,
            showBtnPreview: false,
            showInputPreview: false,
            hasChanged: false,
            config: {},
        };
    },
    filters: {
        arrayToString: function (text) {
            return Array.isArray(text) ? text.join(", ") : text;
        },
    },
    methods: {
        clearImage(uploadItem) {
            this.$Modal.confirm({
                title: "移除圖片",
                content: `您確定要移除目前的${uploadItem.handleUpload.configKey}嗎?`,
                okText: "確定",
                onOk: async () => {
                    if (uploadItem.handleUpload.configKey !== "loginbackground") {
                        this.$emit("clearImgEvent", true);
                        this.previewLoginLogoImg = "";
                    } else {
                        this.previewBackgroundImg = "";
                    }
                    await clearGroupImage({
                        type: uploadItem.handleUpload.configKey,
                        groupName: this.groupName,
                    })
                        .then((result) => {
                            this.$Notice.success({
                                title: this.$i18n.t("global.success"),
                                desc: `${result.data.message}`,
                            });
                            this.$emit("getCustomizeImg");
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                },
            });
        },
        highlighter(code) {
            return highlight(code, languages.css); //returns html
        },
        editItem() {
            this.isEditing = true;
            this.config = Object.assign(this.item.config, {});

            this.editItemData = Object.assign(this.item, {});
        },
        updateItem(value) {
            this.$emit("updateCurrentUse", value);
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: this.$t("global.errorFile"),
                desc: `${file.name} ` + this.$t("rcmtable.validateUnsupportedText"),
            });
        },
        uploadSuccess(response, file, fileList) {
            let uploadItemIndex = Number;
            uploadItemIndex = this.uploadImageItems.findIndex((item) => {
                return item.handleUpload.key == response.uploadname;
            });

            if (response.success == false) {
                return this.$Notice.warning({
                    title: this.$i18n.t("global.errorFile"),
                    desc: `${response.message}`,
                });
            }
            // 更新指定欄位
            let updateField = this.uploadImageItems[uploadItemIndex].handleUpload.configKey;
            this.config[updateField] = 1;

            this.$Notice.success({
                title: this.$i18n.t("global.success"),
                desc: `${response.message}`,
            });
            // this.$emit("updateConfig", this.config);
        },
        //上傳前做圖片預覽後再繼續上傳
        handleBeforeUpload(uploadItem, file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const _base64 = reader.result;
                this[uploadItem.previewImageKey] = _base64;
            };
            return true;
        },
        applyDefaultImg(uploadItem) {
            this[uploadItem.previewImageKey] = this.defaultImgMap[uploadItem.handleUpload.urlKey];
            this.config[uploadItem.handleUpload.configKey] = 0;
        },
        applyDefaultLayout() {
            this.layoutHasChanged = true;
            this.editItemData.layout = JSON.parse(JSON.stringify(this.defaultLayout));
            this.config.layout = 0;
        },
        applyDefaultDescription() {
            this.editItemData.loginDescription = this.defaultDescription;
            this.config.logindescription = this.editItemData.loginDescription;
        },
        updateEditItemData() {
            //update layout & emit value
            if (this.layoutHasChanged == true) {
                updateCustomizeLoginPageLayout({ layout: this.editItemData.layout, groupName: this.groupName })
                    .then((result) => {
                        this.$Notice.success({
                            title: this.$i18n.t("global.success"),
                            desc: `${result.data.message}`,
                        });
                        this.layoutHasChanged = false;
                        this.$emit("updatePrefs");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            this.isEditing = false;
            this.$emit("updateConfig", this.config);
        },
        getPrefsByType(type) {
            getGroupPrefs({ type: type, groupName: this.groupName })
                .then((result) => {
                    this.defaultImgMap = result.data.img;
                    this.defaultDescription = result.data.loginDescription;
                })
                .catch((err) => {});
        },
        getLayoutByType(type) {
            getGroupLoginPageLayout({ type: type, groupName: this.groupName })
                .then((result) => {
                    this.defaultLayout = result.data.loginPageCss;
                })
                .catch((err) => {});
        },
    },
    computed: {
        sketchContent() {
            return {
                background: `url('${this.previewBackgroundImg}') no-repeat center center/cover`,
                overflow: "hidden",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
            };
        },
        uploadImageItems() {
            return [
                {
                    name: this.$t("groupPattern.loginPageObject.backgroundImg"),
                    uploadEndPoint: `loginbackground`,
                    handleUpload: {
                        key: "loginBackground",
                        configKey: "loginbackground",
                        format: ["jpg", "jpeg", "png", "svg"],
                        // 上傳成功後更新的欄位
                        successUpdateFields: "loginbackground",
                        urlKey: "loginbackgroundUrl",
                    },
                    showUploadList: true,
                    previewImageKey: "previewBackgroundImg",
                },
                {
                    name: this.$t("groupPattern.loginPageObject.logo"),
                    uploadEndPoint: `loginlogo`,
                    handleUpload: {
                        key: "loginLogoUpload",
                        configKey: "loginlogo",
                        format: ["jpg", "jpeg", "png", "svg"],
                        // 上傳成功後更新的欄位
                        successUpdateFields: "logoUrl",
                        urlKey: "loginlogoUrl",
                    },
                    showUploadList: true,
                    previewImageKey: "previewLoginLogoImg",
                },
            ];
        },
    },
    mounted() {
        this.getPrefsByType("default");

        this.getLayoutByType("default");
    },
};
</script>
<style scoped>
.ivu-form-item >>> .ivu-input {
    border: none;
}
.loginCard {
    background: transparent;
    border: none;
    text-align: center;
    min-width: 200px;
}
.ivu-input-wrapper >>> .ivu-input-suffix {
    padding-right: 15px;
}

.ivu-input-wrapper >>> .ivu-input-suffix i {
    line-height: 40px;
}
.login-description {
    font-size: 28px;
    color: #fff;
    margin-bottom: 24px;
}
@media screen and (min-width: 1280px) {
    .login-description {
        font-size: 28px;
    }
}
@media (max-width: 1080px) and (min-width: 960px) {
    .login-description {
        font-size: 24px;
    }
}
@media screen and (max-width: 960px) {
    .login-description {
        font-size: 20px;
    }
}

.codeEditor {
    background: #2d2d2d;
    color: #ccc;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    margin-bottom: 20px;
}
.codeEditor >>> .prism-editor__textarea:focus {
    outline: none;
}
pre {
    padding: 5px;
}

button {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/LoginPageCard.vue